import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ManagerListComponent } from './manager-list/manager-list.component';
import { UserListComponent } from './user-list/user-list.component';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { AdminDashboardComponent } from './admin-dashboard.component';
import { PromocodeComponent } from './promocode/promocode.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 


@NgModule({
  declarations: [
    ManagerListComponent,
    PromocodeComponent,
    UserListComponent,
    TransactionDetailsComponent,
    AdminDashboardComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule
  ]
})
export class AdminDashboardModule { }
